import { render, staticRenderFns } from "./safety_list.vue?vue&type=template&id=38a9186f&"
import script from "./safety_list.vue?vue&type=script&lang=js&"
export * from "./safety_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports